import { Alert } from 'react-bootstrap';
import { readonlyAlert } from './styles';

const ReadonlyAlert = () => {
	return (
		<Alert variant="danger" className={readonlyAlert}>
			<span>READ-ONLY MODE!</span>

			<span>You are not allowed to update the course.</span>

			<span>READ-ONLY MODE!</span>
		</Alert>
	);
};

export default ReadonlyAlert;
